import React from 'react'
import { FaFacebookF, FaWhatsapp, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';

function ElectricalSidebar() {
    const baseColor = '#08717A';

    const buttonStyle = {
        width: 40,
        height: 40,
        backgroundColor: baseColor,
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        border: 'none',
        cursor: 'pointer',
        fontSize: '18px',
        transition: 'all 0.3s ease',
        textDecoration: 'none',
        
    };

    const hoverColors = {
        facebook: '#0d8f94',
        whatsapp: '#1da1f2',
        instagram: '#e1306c',
        linkedin: '#0a66c2',
    };
  return (
    <div className="col-lg-3 col-md-4 col-12">
      <div
        className="sidebar p-4 bg-white rounded shadow-sm"
        style={{ position: 'sticky', top: '100px', borderLeft: '4px solid #08717A' }}
      >
        <h5 className="mb-4 text-primary">Power Distribution </h5>
        <Link
          to="/"
          rel="noopener noreferrer"
          className="custom-btn"
          >
          Back To Home
      </Link>
        <Link
          to="/ht-switcher"
          rel="noopener noreferrer"
          className="custom-btn"
          >
          HT Switchgear
          </Link>
          <Link
          to="/load-break-switch"
          rel="noopener noreferrer"
          className="custom-btn"
          >
          Load Break Switch
          </Link>
          <Link
          to="/apfc"
          rel="noopener noreferrer"
          className="custom-btn"
          >
          APFC
          </Link>
          <Link
          to="/mcc-panel"
          rel="noopener noreferrer"
          className="custom-btn"
          >
          MCC Panel
          </Link>
          <Link
          to="/synchronizing-panel"
          rel="noopener noreferrer"
          className="custom-btn"
          >
          Synchronizing Panel
          </Link>
          <Link
          to="/lt-switchgear"
          rel="noopener noreferrer"
          className="custom-btn"
          >
          LT Switchgear
          </Link>
          <Link
          to="/ats-panel"
          rel="noopener noreferrer"
          className="custom-btn"
          >
          ATS Panel
          </Link>
          <Link
          to="/power-distribution"
          rel="noopener noreferrer"
          className="custom-btn"
          >
          POWER & DISTRIBUTION
          </Link>
          <Link
          to="/ht-lt-avr"
          rel="noopener noreferrer"
          className="custom-btn"
          >
            HT & LT
          </Link>
        <h3 className="mt-5 mb-3 text-secondary">Follow Us:</h3>
        <div className="d-flex justify-content-center gap-2">
          <a
              href="#"
              aria-label="Facebook"
              style={buttonStyle}
              onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = hoverColors.facebook;
              e.currentTarget.style.color = '#fff';
              }}
              onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = baseColor;
              e.currentTarget.style.color = '#fff';
              }}
          >
              <FaFacebookF />
          </a>

          <a
              href="#"
              aria-label="Whatsapp"
              style={buttonStyle}
              onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = hoverColors.whatsapp;
              e.currentTarget.style.color = '#fff';
              }}
              onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = baseColor;
              e.currentTarget.style.color = '#fff';
              }}
          >
              <FaWhatsapp />
          </a>

          <a
              href="#"
              aria-label="Instagram"
              style={buttonStyle}
              onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = hoverColors.instagram;
              e.currentTarget.style.color = '#fff';
              }}
              onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = baseColor;
              e.currentTarget.style.color = '#fff';
              }}
          >
              <FaInstagram />
          </a>

          <a
              href="#"
              aria-label="LinkedIn"
              style={buttonStyle}
              onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = hoverColors.linkedin;
              e.currentTarget.style.color = '#fff';
              }}
              onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = baseColor;
              e.currentTarget.style.color = '#fff';
              }}
          >
              <FaLinkedinIn />
          </a>
          </div>
      </div>
    </div>
  )
}

export default ElectricalSidebar